<template>
  <div class="row_group">
    <div class="group_name grid_group_name" :style="{width: grid_width+'px'}"></div>
    <div v-if="showGroup">
    <GridRow v-for="row in items" v-bind:key="row.spw.ID" :row="row"></GridRow>
    </div>
  </div>
</template>

<script>
import GridRow from './GridRow';
// import Toolbar from './Toolbar';
import { mapState } from 'vuex'
import { mapGetters } from 'vuex'
// import { mapActions } from 'vuex'
// import { mapMutations } from 'vuex'
// import { mapFields } from 'vuex-map-fields';

  export default {
    props: ['groupName','items'],
    name: 'RowGroup',
    components: {
    //   Row,
    GridRow
    },
    data: () => ({
  
    }),
    computed: {
        ...mapState(['groupBy','groups']),
      ...mapGetters(['min_date','max_date','days','grid_width']),
      showGroup(){
        if (!(this.groupName in this.groups)){
          return true
        }
        else{
          return this.groups[this.groupName]
        }
      
      }
 
    }
  }

</script>
<style>
.grid_group_name{
    background: linear-gradient(90deg, #dfdfdf 1px, #efefef 1px);
  background-size: 60px 60px;
  background-position: 0px 0px;
  border-bottom: solid 1px #dfdfdf;
}
</style>